/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumPersonaFisicaDTORole =
  (typeof EnumPersonaFisicaDTORole)[keyof typeof EnumPersonaFisicaDTORole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumPersonaFisicaDTORole = {
  VIEWER: 'VIEWER',
  TITOLARE: 'TITOLARE',
  EDITOR: 'EDITOR',
} as const;
